import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadFaviconRequest } from '../../actions/loadFavicon';

import { getLoadFaviconError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadFaviconHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadFaviconRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadFaviconError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadFaviconHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
